module.exports = __webpack_public_path__ + "img/dj.16e3de24.svg";